<template>
  <div id="app">
    <Header />
    <div id="content">
      <div class="container">
        <router-view/>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
html {
  background: #fff;
  color: #333;
  font-family: 'Work Sans', 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* transition: background 0.4s; */
  font-size: 16px;
  line-height: 24px;
}

*, *:before, *:after {
  box-sizing: border-box;
}

h1 {
  font-size: 24px;
  line-height: 32px;
  margin: 32px 0 16px 0;
}

h2 {
  font-size: 20px;
  line-height: 32px;
  margin: 40px 0 16px 0;
}

p {
  margin: 16px 0;
}

p.note {
  color: #333;
}
p.note strong {
  color: #000;
}

body {
  margin: 0;
}

code, pre {
  font-family: "Roboto Mono", monospace;
}

code {
  word-break: break-all;
}

pre {
  max-width: 100%;
  overflow: scroll;
}

a {
  /* color: #535db4; */
  color: #001ddd;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

#nav {
  padding: 48px 56px;
  width: 400px;
  background: #1D1E1F;
}

#content {
  padding: 0 0 48px 0;
}

.container {
  padding: 0 16px;
}

@media screen and (min-width: 640px) {
  .container {
    max-width: 960px;
    padding: 0 24px;
    margin: 0 auto;
  }
}

</style>
